import { render, staticRenderFns } from "./ExerciseCategories.vue?vue&type=template&id=6d24f501"
import script from "./ExerciseCategories.vue?vue&type=script&lang=js"
export * from "./ExerciseCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports